import { render, staticRenderFns } from "./asides.vue?vue&type=template&id=1ef13046"
import script from "./asides.vue?vue&type=script&lang=js"
export * from "./asides.vue?vue&type=script&lang=js"
import style0 from "./asides.vue?vue&type=style&index=0&id=1ef13046&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports